<template>
  <div :style="`--accent-nav: ${accentColor};`">
    <div
      class="row d-flex justify-content-between align-items-center mt-3 pr-lg-3"
    >
      <div class="col-lg-6 d-flex align-items-center">
        <PageTitle :titles="[...pageTitles]" :data-count="dataCount" />
      </div>
      <div
        class="wrap col-lg-6 d-flex justify-content-end align-items-center mb-2"
      >
        <SearchFilter
          v-if="showingDataLength || hasFilters"
          v-model.trim="search"
          class="wrap col-lg-6 col-md-6"
        />
        <sectorFilter
          v-if="hasSectorFilter"
          @setFilter="FilterSectors"
          class="wrap col-lg-4 col-md-6"
        ></sectorFilter>
        <b-dropdown
          v-if="hasUsageFilter"
          variant="none"
          size="sm"
          block
          class="wrap col-lg-5 col-md-6 customDropdown"
        >
          <template #button-content>
            <span class="dropdownText">{{ usageFilterLabel }}</span>
          </template>
          <b-dropdown-item @click="usageFilter = 'all'">
            Todos os {{ usageEntity.noun }}
          </b-dropdown-item>
          <b-dropdown-item @click="usageFilter = 'associated'">
            {{ usageEntity.noun }} associados a setores
          </b-dropdown-item>
          <b-dropdown-item @click="usageFilter = 'unused'">
            {{ usageEntity.noun }} não utilizados
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div v-if="hasFarmFilter" class="container-dropdown">
      <div class="row around-xs">
        <div class="col-xs-6 pt-1">
          <b-btn
            block
            size="sm"
            :variant="selectedFarms.length ? '3v3' : 'outline-3v3'"
            @click="showFarmModal = true"
          >
            Filtrar cultivar<span v-if="selectedFarms.length">
              ({{ selectedFarms.length }})</span
            >
          </b-btn>
        </div>
        <div class="col-xs-6 pt-1">
          <b-btn
            block
            size="sm"
            :variant="selectedSoils.length ? '3v3' : 'outline-3v3'"
            @click="showSoilModal = true"
          >
            Filtrar solo<span v-if="selectedSoils.length">
              ({{ selectedSoils.length }})</span
            >
          </b-btn>
        </div>
      </div>
    </div>

    <PickEquipmentsModal
      v-if="showFarmModal"
      v-model="showFarmModal"
      typeName="Cultivares"
      selectType="selectCheckBox"
      :equipments="farmOptions"
      :selected="selectedFarms"
      :equipments-handle="{}"
      @selected="(sel) => (selectedFarms = sel ? [...sel] : [])"
    />
    <PickEquipmentsModal
      v-if="showSoilModal"
      v-model="showSoilModal"
      typeName="Solos"
      selectType="selectCheckBox"
      :equipments="soilOptions"
      :selected="selectedSoils"
      :equipments-handle="{}"
      @selected="(sel) => (selectedSoils = sel ? [...sel] : [])"
    />

    <spinner v-if="isLoading" class="col-xs-12 center-xs" />
    <div v-if="!hideCards && !isLoading">
      <div class="w-100 wrapper-cards p-1 p-lg-0">
        <div v-if="showingDataLength" class="w-100">
          <div class="row my-3 pr-lg-3">
            <div
              v-for="(item, index) in renderedData"
              :key="item.NAME ? item.NAME : index"
              class="col-xs-12 col-custom col-md-4 col-sm-6 mb-3"
            >
              <RegisterCardTemplate
                :tags="cardTags"
                v-model="item.isSelected"
                :item="item"
                is-admin
                :title="item.NAME"
                :action-component="actionComponent"
                :columns="columns"
                :sort-columns-by-key="sortColumnsByKey"
                :icon="icon"
                :footer-button="footerButton"
                :hide-actions="hideActions"
                @click-footer-action="handleFooterComponentClick"
                @edit-single-item="selectSingleItem"
                @TagsModal="TagsModal"
              />
            </div>

            <div
              v-if="canShowMore"
              class="my-2 w-100 d-flex justify-content-center align-items-center"
            >
              <div class="mr-3">{{ showingDataLength }} de {{ dataCount }}</div>

              <button class="btn btn-show-more" @click="showMore">
                Mostrar mais
              </button>
            </div>
          </div>
        </div>

        <NoDataSad
          v-else
          :has-filters="hasFilters"
          :data-title="selectedTitle"
        />

        <div class="py-5 d-lg-none">
          <div class="py-5" />
        </div>
      </div>

      <component
        v-if="showForm"
        :is="sideActionComponent"
        :item-to-edit="itemToEdit"
        :items="data"
        :form-type="formType"
        @close-form="closeForm"
        @get-data-again="getData"
      />

      <ActionButtons
        v-if="showActions"
        @add="handlerAdd"
        :hide-create="hideCreate"
        :hide-delete="hideDelete"
        @update="handlerUpdate"
        @delete="handlerDelete"
        :selected-length="selectedCount"
        :restrictive-close="restrictiveClose"
      />

      <ActionButtonModal
        v-if="footerButton"
        v-model="showFooterComponent"
        :item="itemModal"
        :modal-content-component="footerButton.component"
        :modal-prefix="footerButton.modalPrefix"
        :modal-size="footerButton.modalSize"
        @close-action-modal="closeForm"
      />

      <DeleteModal
        v-model="showDeleteModal"
        :selected-items="selectedItems"
        :reasons-of-locked-delete="selectedItems.map((v) => v.NAME)"
        :get-list-of-blockers-with-ids="getListOfBlockersWithIds"
        :selected-title="selectedTitle"
        :dependent-title="dependentTitle"
        :check-before-delete="checkBeforeDelete"
        :blocked-items-resolver="blockedItemsResolver"
        :delete-item-func="deleteItemFunc"
        @confirm="getData"
      />
      <SectorTagsModal
        v-model="showTagsModal"
        :item="TagsModalItem"
        :modalTitle="TagsModalTitle"
        :modalBody="TagsModalBody"
      ></SectorTagsModal>
    </div>
  </div>
</template>

<script>
// TODO IMPLEMENT SIDEREGISTER TEMPLATE
// import SideRegister from "@/pages/temps/components/SideRegister";
import AlertForm from "@/pages/alertPage/components/AlertForm";
import DirForm from "@/pages/alertPage/components/DirForm";
import FarmForm from "@/pages/registerPages/Management/components/FarmForm";
import SoilForm from "@/pages/registerPages/Management/components/SoilForm";
import SectorForm from "@/pages/registerPages/Sectors/components/SectorForm";
import SectorTagsModal from "@/pages/registerPages/Sectors/components/SectorTagsModal.vue";
import sectorFilter from "@/pages/registerPages/Sectors/components/sectorFilter.vue";
import GroupForm from "@/pages/registerPages/Users/components/GroupForm.vue";
import UserForm from "@/pages/registerPages/Users/components/UserForm.vue";
import ActionButtonModal from "@/pages/temps/components/ActionButtonModal";
import ActionButtons from "@/pages/temps/components/ActionButtons";
import DeleteModal from "@/pages/temps/components/DeleteModal";
import NoDataSad from "@/pages/temps/components/NoDataSad";
import PageTitle from "@/pages/temps/components/PageTitle";
import RegisterCardTemplate from "@/pages/temps/components/RegisterCardTemplate";
import SearchFilter from "@/pages/temps/components/SearchFilter";
import PickEquipmentsModal from "@/common/components/PickEquipmentsModal.vue";
import { farmUseCase } from "@/api/modules/farm/useCases";
import { soilUseCase } from "@/api/modules/soil/useCases";
import { managementSectorUseCases } from "@/api/modules/sector/useCases";
import store from "@/store";
export default {
  components: {
    RegisterCardTemplate,
    DeleteModal,
    SearchFilter,
    PageTitle,
    ActionButtons,
    ActionButtonModal,
    SoilForm,
    FarmForm,
    NoDataSad,
    AlertForm,
    DirForm,
    SectorForm,
    GroupForm,
    UserForm,
    SectorTagsModal,
    sectorFilter,
    PickEquipmentsModal,
  },

  props: {
    actionComponent: {
      type: String,
      default: "",
    },
    pageTitles: {
      type: Array,
      default: () => [],
    },
    cardTags: {
      type: Array,
      default: () => [],
    },
    footerButton: {
      type: Object,
      default: () => {
        {
        }
      },
    },
    checkBeforeDelete: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: String,
      default: "",
    },
    getListOfBlockersWithIds: {
      type: Function,
      default: () => {},
    },
    blockedItemsResolver: {
      type: Function,
      default: null,
    },
    accentColor: {
      type: String,
      default: "...",
    },
    columns: {
      type: Array,
      default: () => [],
    },
    getDataFunc: {
      type: Function,
      default: () => {},
    },
    deleteItemFunc: {
      type: Function,
      default: () => {},
    },
    hideCards: {
      type: Boolean,
      default: false,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    restrictiveClose: {
      type: Boolean,
      default: false,
    },
    selectedTitle: {
      required: false,
      type: String,
      default: "",
    },
    dependentTitle: {
      required: false,
      type: String,
      default: "",
    },
    sortColumnsByKey: {
      type: String,
      default: "measurement",
    },
    sideActionComponent: {
      required: false,
      type: String,
      default: "",
    },
    orderCardColumnsByDesc: {
      type: Boolean,
      default: false,
    },
    hideCreate: {
      type: Boolean,
      default: false,
    },
    hideAdd: {
      type: Boolean,
      default: false,
    },
    hideDelete: {
      type: Boolean,
      default: false,
    },
    modalSize: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      // defaultPerPage: 50,
      // perPage: 50,
      itemToEdit: {},
      itemModal: {},
      isLoading: true,
      data: [],
      search: "",
      formType: null,
      showForm: false,
      showFooterComponent: false,
      showDeleteModal: false,
      showTagsModal: false,
      TagsModalTitle: "",
      TagsModalBody: [],
      TagsModalItem: {},
      SectorFilterType: "",
      allFarms: [],
      allSoils: [],
      selectedFarms: [],
      selectedSoils: [],
      showFarmModal: false,
      showSoilModal: false,
      usageFilter: "all",
      usedFarmIds: new Set(),
      usedSoilIds: new Set(),
    };
  },
  watch: {
    search: (newValue) => {
      // console.log(newValue);
    },
    inputFilters: {
      handler(newValue) {
        const allQuery = {
          ...this.queryFilters,
          ...newValue,
        };

        return this.$router.push({ query: allQuery });
      },
      deep: true,
    },
    routePath: {
      async handler() {
        this.search = "";
        this.selectedFarms = [];
        this.selectedSoils = [];
        this.usageFilter = "all";
        this.perPage = this.defaultPerPage;
        this.setHeadTitle();
        await this.getData();
        this.filterByQueryParams();
        if (this.hasFarmFilter) {
          this.loadFarms();
          this.loadSoils();
        }
        if (this.hasUsageFilter) this.loadSectorUsage();
      },
      immediate: true,
    },
    formsShowingState: {
      handler(newValue, oldValue) {
        const notShowingItems = newValue.filter((val) => !val).length;
        const notShowingOldItems =
          oldValue && oldValue.filter((val) => !val).length;

        if (oldValue && notShowingItems > notShowingOldItems) {
          this.setQueryParams({
            isClear: true,
          });
        }
      },
    },
  },
  computed: {
    hasSectorFilter() {
      if (this.$route.path == "/registers/sectors") {
        return true;
      }
    },
    hasFarmFilter() {
      return this.$route.path == "/registers/sectors";
    },
    // Filtro de uso (todos / associados a setores / não utilizados) nas telas de cultivar e solo.
    usageEntity() {
      if (this.$route.path == "/registers/farms_dap") {
        return { noun: "Cultivares", used: this.usedFarmIds };
      }
      if (this.$route.path == "/registers/soil") {
        return { noun: "Solos", used: this.usedSoilIds };
      }
      return null;
    },
    hasUsageFilter() {
      return !!this.usageEntity;
    },
    usageFilterLabel() {
      if (!this.usageEntity) return "";
      const noun = this.usageEntity.noun;
      if (this.usageFilter === "associated") return `${noun} associados a setores`;
      if (this.usageFilter === "unused") return `${noun} não utilizados`;
      return `Todos os ${noun}`;
    },
    // Opções interdependentes: cada lista sai dos setores que já passam pelos OUTROS filtros
    // (busca + o outro dimensionamento), sempre restrita aos que têm setor cadastrado.
    farmOptions() {
      const source = this.data.filter((item) =>
        this.matchesFilters(item, { useSearch: true, useSoils: true })
      );
      const usedIds = new Set(source.filter((s) => s.ID_FARM).map((s) => s.ID_FARM));
      return this.allFarms.filter((farm) => usedIds.has(farm.ID));
    },
    soilOptions() {
      const source = this.data.filter((item) =>
        this.matchesFilters(item, { useSearch: true, useFarms: true })
      );
      const usedIds = new Set(source.filter((s) => s.ID_SOIL).map((s) => s.ID_SOIL));
      return this.allSoils.filter((soil) => usedIds.has(soil.ID));
    },
    showActions() {
      if (this.hideActions == true || store.getters.isAdmin == false)
        return false;
      else return true;
    },
    canShowMore() {
      return !!(this.perPage < this.dataCount);
    },
    inputFilters() {
      return {
        search: this.search || undefined,
      };
    },
    formsShowingState() {
      return [this.showForm, this.showFooterComponent, this.showDeleteModal];
    },
    queryFilters() {
      return {
        id: this.$route.query && this.$route.query.id,
        action: this.$route.query && this.$route.query.action,
        search: this.$route.query && this.$route.query.search,
      };
    },
    currentFilters() {
      return {
        search: this.search,
        ...this.queryFilters,
      };
    },
    hasFilters() {
      return !!this.currentFilters.search;
    },
    showingDataLength() {
      return this.renderedData.length;
    },
    renderedData() {
      if (this.isLoading && !this.filteredData.length) {
        return Array.from(Array(20).keys()).map((i) => ({ id: i }));
      }

      return this.filteredData.slice(0, this.perPage);
    },
    routePath() {
      return this.$route.path;
    },
    selectedItems() {
      return this.data.filter((val) => val.isSelected);
    },
    headTabTitle() {
      return this.pageTitles
        .map((title, i) => {
          if (!i) {
            return `${title.charAt(0)}.`;
          }

          return title.charAt(0).toUpperCase() + title.slice(1);
        })
        .join(" ");
    },
    // itemToEdit() {
    //   // alteração feita para evitar BUG do select com edit ( esse so funciona com o botão no card)
    //   const lastIndex = this.selectedItems.length - 1;
    //   return this.selectedItems[lastIndex];
    // },
    dataCount() {
      return (this.filteredData && this.filteredData.length) || 0;
    },
    selectedCount() {
      return (this.selectedItems && this.selectedItems.length) || 0;
    },
    filteredData() {
      return this.data.filter((item) => {
        if (
          !this.matchesFilters(item, {
            useSearch: true,
            useFarms: true,
            useSoils: true,
          })
        ) {
          return false;
        }

        if (this.hasUsageFilter && this.usageFilter !== "all") {
          const used = this.usageEntity.used.has(item.ID);
          if (this.usageFilter === "associated" && !used) return false;
          if (this.usageFilter === "unused" && used) return false;
        }

        return true;
      });
    },
  },
  methods: {
    // Casa um setor contra o subconjunto de filtros habilitado. Excluir uma dimensão permite
    // derivar as opções daquele filtro a partir do resultado dos demais (interdependência).
    matchesFilters(item, { useSearch, useFarms, useSoils } = {}) {
      if (
        useSearch &&
        this.search &&
        item.NAME.toLowerCase().indexOf(this.search.toLowerCase()) === -1
      ) {
        return false;
      }
      if (useFarms && this.hasFarmFilter && this.selectedFarms.length) {
        if (!this.selectedFarms.some((f) => f.ID === item.ID_FARM)) return false;
      }
      if (useSoils && this.hasFarmFilter && this.selectedSoils.length) {
        if (!this.selectedSoils.some((s) => s.ID === item.ID_SOIL)) return false;
      }
      return true;
    },
    TagsModal(title, body, item) {
      this.TagsModalTitle = title;
      this.TagsModalBody = body;
      this.TagsModalItem = item;
      this.showTagsModal = !this.showTagsModal;
    },
    selectSingleItem(item) {
      this.unselectAll();

      this.selectSingleItem(item.ID);
    },
    async FilterSectors(selected) {
      this.SectorFilterType = selected;
      await this.getData();
    },
    async loadFarms() {
      const [farms] = await farmUseCase().show.execute();
      if (farms) {
        this.allFarms = farms
          .map((farm) => ({ ID: farm.ID, NAME: farm.NAME }))
          .sort((a, b) => a.NAME.localeCompare(b.NAME));
      }
    },
    async loadSoils() {
      const [soils] = await soilUseCase().show.execute();
      if (soils) {
        this.allSoils = soils
          .map((soil) => ({ ID: soil.ID, NAME: soil.NAME }))
          .sort((a, b) => a.NAME.localeCompare(b.NAME));
      }
    },
    // Conjuntos de IDs de cultivar/solo em uso por algum setor (para o filtro de uso).
    async loadSectorUsage() {
      const [rows] = await managementSectorUseCases().show.execute();
      const farmIds = new Set();
      const soilIds = new Set();
      (rows || []).forEach((r) => {
        if (r.ID_FARM) farmIds.add(r.ID_FARM);
        if (r.ID_SOIL) soilIds.add(r.ID_SOIL);
      });
      this.usedFarmIds = farmIds;
      this.usedSoilIds = soilIds;
    },
    showMore() {
      let newPerPageVal = this.perPage + this.defaultPerPage;

      this.perPage =
        newPerPageVal > this.dataCount ? this.dataCount : newPerPageVal;
    },
    filterByQueryParams() {
      const { id, action, search } = this.currentFilters;

      let item;
      if (id) {
        if (this.data && this.data.length) {
          console.log(this.data);
          item = this.data.find((val) => val.ID == id);
          item = item || this.data[0];
          item.isSelected = true;
          this.itemToEdit = item;
        }
      }

      if (action == "edit" && !this.hideAdd) {
        this.handlerUpdate();
      } else if (action == "add" && !this.hideCreate) {
        this.handlerAdd();
      } else if (action == "act" && item) {
        this.handleFooterComponentClick(item);
      }

      if (search) {
        this.search = search;
      }
    },
    async setQueryParams({ id, isUpdate, isAction, isCreate, isClear }) {
      if (isClear) {
        // return this.$router.push({query: {}});
        const hasCurrentRouteQueryParams =
          JSON.stringify(this.$route.query) !== JSON.stringify({});
        if (hasCurrentRouteQueryParams && this.search == !"") {
          return this.$router.push({ query: {} }).catch(() => {});
        }
      }
      const currentQueryId = this.queryFilters.id;
      let action = "";

      if (isUpdate) {
        action = "edit";
      } else if (isAction) {
        action = "act";
      } else if (isCreate) {
        action = "add";
      }

     if (id && id != currentQueryId && action) {
      this.$router.push({
        query: {
          id,
          action,
        },
      }).catch(() => {});
    }
    },
    clearQuery() {
      if (this.$router && Object.keys(this.$route.query).length > 0) {
        this.$router.push({ query: {} }).catch(() => {});
      }
    },
    setHeadTitle() {
      this.$emit("title-change", this.headTabTitle);
    },
    async getData() {
      this.isLoading = true;
      this.data = [];
      try {
        const [response] = await this.getDataFunc();
        if (!response) {
          this.isLoading = false;
          return [];
        }
        if (
          (this.SectorFilterType == "management_sectors") &
          this.hasSectorFilter
        ) {
          this.data =
            response
              .filter((r) => r.IS_MANAGEMENT)
              .map((r) => {
                r.isSelected = false;
                return r;
              }) || [];
        } else if (
          (this.SectorFilterType == "simple_sectors") &
          this.hasSectorFilter
        ) {
          this.data =
            response
              .filter((r) => !r.IS_MANAGEMENT)
              .map((r) => {
                r.isSelected = false;
                return r;
              }) || [];
        } else {
          this.data =
            response.map((r) => {
              r.isSelected = false;
              return r;
            }) || [];
        }

        this.isLoading = false;
      } catch (e) {
        console.error(e);

        alert("Ocorreu um erro ao solicitar dados dos cards", "e");
        this.data = [];
        this.isLoading = false;
        this.restartStatePage();
      }
    },
    selectSingleItem(itemToSelect) {
      const item = this.data.find((val) => val.ID == itemToSelect.ID);

      item.isSelected = true;
      this.handlerUpdate(item);
    },
    unselectAll() {
      this.data.map((item) => {
        item.isSelected = false;
        return item;
      });
    },
    restartStatePage() {
      // this.search = "";
      this.unselectAll();
      this.formType = null;
      this.handleFormShow(false);
      this.handleFooterComponentShow(false);
      this.showDeleteModal = false;
    },
    handleFormShow(bool) {
      this.showForm = !!bool;
    },
    handleFooterComponentShow(bool) {
      this.showFooterComponent = !!bool;
    },
    handleFooterComponentClick(item) {
      this.setQueryParams({
        id: item.ID,
        isAction: true,
      });

      this.itemModal = item;
      this.handleFooterComponentShow(true);
    },
    handlerAdd() {
      this.formType = "add";
      this.handleFormShow(true);
    },
    closeForm() {
      this.formType = null;
      this.handleFormShow(false);
      this.unselectAll();

      // limpar query apos fechar o formulário
      this.clearQuery();
    },
    handlerUpdate(item) {
      if (item) {
        this.itemToEdit = item;
      }

      this.handleFormShow(true);
      this.formType = "edit";

      this.setQueryParams({
        id: this.itemToEdit.ID,
        isUpdate: true,
      });
    },
    handlerDelete() {
      this.showDeleteModal = true;
    },
  },
};
</script>

<style scoped>
/* Moldura do dropdown de filtro de uso (mesma do sectorFilter.customDropdown). */
.customDropdown {
  display: flex;
  align-items: center;
  text-align: left !important;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
  color: #495057;
}

/* .card {
  min-width: 300px;
} */

.wrapper-cards {
  max-height: calc(100vh - (var(--size-bars) + var(--size-bars)));
  overflow-y: auto;
  overflow-x: hidden;
  flex-wrap: wrap;
}
/* 5 cards por linha */
.col-custom {
  flex: 0 0 20%;
  max-width: 20%;
}
.btn-show-more {
  background-color: var(--accent-nav);
  color: white;
}
/* 4 cards por linha */
@media (max-width: 1199px) {
  .col-custom {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

/* 3 cards por linha */
@media (max-width: 992px) {
  .col-custom {
    flex: 0 0 33.33%;
    max-width: 33.33%;
  }
}

/* 2 cards por linha */
@media (max-width: 768px) {
  .col-custom {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

/* 1 card por linha */
@media (max-width: 590px) {
  .col-custom {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
